import { render } from "./TheReportsTable.vue?vue&type=template&id=523ae4ce"
import script from "./TheReportsTable.vue?vue&type=script&lang=js"
export * from "./TheReportsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__